import { IconPhone as TablerIconPhone } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconPhone = /*#__PURE__*/ createOutlineIcon(TablerIconPhone, 'IconPhone');
